import './App.css';
import the_river_between_us from "./The_River_Between_Us__by_Ravin_Kumar.pdf"

function App() {
  return (
    <div>
    <center><h1><b><i> Short Stories </i></b></h1></center>
   <br/>
   <div class="middle">
    <ol>
    <li>
    <b><u><a href={the_river_between_us} target="_blank" rel="noopener noreferrer" style={{color:"black"}}>The River Between Us: Because Even Rivers Choose Love</a></u></b>.<br/>
    
     <p align="justify">
The River Between Us is a poetic and heartwarming romantic short story by <a href="https://mr-ravin.github.io" target="_blank" rel="noopener noreferrer">Ravin Kumar</a>, exploring the quiet power of childhood connection, fate, and timeless love. Set across a serene village and a modern cruise ship, the story follows Ravin and Pooja—two soulmates bound by paper boats, a copper ring, and a mysterious letter “R”. As life separates them and time flows on like a river, a quiet reunion unfolds through symbols, silence, and destiny.

This story blends memory, emotion, and subtle symbolism to remind us that true love never forgets—and always finds its way home.
     </p>


     <p align="justify">
     <b><i>Available on</i></b>:
     
     <b> 1. </b> <a target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/books/details?id=zgZ0EQAAQBAJ">Google Play</a>
     <b> 2. </b> <a target="_blank" rel="noopener noreferrer" href="https://books.google.co.in/books/about?id=zgZ0EQAAQBAJ">Google Books</a>
     <b> 3. </b> <a target="_blank" rel="noopener noreferrer" href="https://mr-ravin.github.io/The_River_Between_Us__by_Ravin_Kumar.pdf">Github</a>
     <b> 4. </b> <a target="_blank" rel="noopener noreferrer" href="https://archive.org/details/the-river-between-us--by-ravin-kumar">Archive.org</a>
     <b> 5. </b> <a target="_blank" rel="noopener noreferrer" href="https://www.scribd.com/document/1009108034/The-River-Between-Us-By-Ravin-Kumar">Scribd</a>
     <b> 6. </b> <a target="_blank" rel="noopener noreferrer" href="https://leanpub.com/the_river_between_us__by_ravin_kumar">Leanpub</a>
     </p>
    </li>
    </ol>

    </div>
    </div>
  );
}

export default App;
